import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Button, Col, Form, Row } from 'react-bootstrap';
import classNames from 'classnames';
import { useForm } from 'react-hook-form';
import BootTextField from 'components/common/custom/forms/BootTextField';

const LockScreenForm = ({  ...rest }) => {
  
  const { control, handleSubmit } = useForm({
    defaultValues:{
        password:''
    }
  })

  return (
    <Row
      {...rest}
      as={Form}
      className={classNames('gx-2 mt-3')}
      onSubmit={handleSubmit}
    >
      <Col className='mt-3'>
        <BootTextField 
        name="password"
        control={control}
        placeholder='password'
        type="password"
        isRequired
        />
      </Col>
      <Col xs='auto' className='mt-3'>
        <Button
          variant="primary"
          type="submit"
        >
          Login
        </Button>
      </Col>
    </Row>
  );
};


export default LockScreenForm;
